module.exports = __webpack_public_path__ + "img/icon-reports.9ddf6504.svg";